<template>
  <main
    class="w-full h-full flex justify-center under18 relative tablet:static"
  >
    <div
      class="text-center max-w-8xl mx-auto mt-[80vw] tablet:mt-[48vw] laptop:mt-[23vw] desktop:mt-[420px] relative z-30"
    >
      <h1
        class="tch font-bold text-[5.2vw] leading-[5.5vw] tablet:text-[4.5vw] tablet:leading-[4.5vw] laptop:text-[2.5vw] laptop:leading-[2.5vw] desktop:text-5xl desktop:leading-[45px]"
      >
        Ce site est exclusivement réservé<br />
        aux personnes majeures
      </h1>
      <p
        class="tch text-[5vw] py-[2vw] tablet:text-[4vw] tablet:py-[2vw] laptop:text-[3vw] laptop:leading-[3vw] desktop:text-2xl laptop:py-[1vw] desktop:py-4"
      >
        Avez-vous plus de 18 ans ?
      </p>
      <div
        class="flex justify-center items-center gap-[5.6vw] tablet:gap-[4vw] laptop:gap-[1.6vw] desktop:gap-6"
      >
        <router-link to="/home">
          <button
            class="tch button !w-auto tablet:!w-[15vw] lg:!w-[10vw] desktop:!w-32 text-center justify-center"
          >
            OUI
          </button>
        </router-link>
        <button
          class="tch button !w-auto tablet:!w-[50vw] lg:!w-[10vw] desktop:!w-32 text-center justify-center"
          @click="openPopup"
        >
          NON
        </button>
      </div>
    </div>
    <div class="laptop:hidden w-full absolute bottom-0">
      <img
        src="@/assets/images/bas-tablette-village.png"
        class="w-full tablet:hidden"
      />
      <img
        src="@/assets/images/bas-tablette-village.png"
        class="w-full hidden tablet:block laptop:hidden"
      />
    </div>
    <PopupView ref="popupRef" v-if="isOpen" @close="closePopup">
      <div class="text-center w-full py-16">
        <h1
          class="text-[10vw] tablet:text-[8vw] laptop:text-[4vw] desktop:text-7xl font-bold tch"
        >
          DÉSOLÉ
        </h1>
        <p
          class="text-[8vw] tablet:text-[6vw] laptop:text-[3vw] leading-none desktop:text-5xl tch font-normal"
        >
          Vous ne pouvez pas<br />participer
        </p>
      </div>
    </PopupView>
  </main>
</template>

<script setup>
import { ref } from "vue";
import PopupView from "@/components/PopupView.vue";

const isOpen = ref(false);
const popupRef = ref(null);

const openPopup = () => {
  isOpen.value = true;
};

const closePopup = () => {
  isOpen.value = false;
};
</script>

<style lang="scss">
.under18 {
  min-height: 720px;
  background-image: url("@/assets/images/fond-logo2.png");
  background-size: 1919px auto;
  background-position: top -550px left calc(50% - 35px);
  background-repeat: no-repeat;

  @media (max-width: 1919px) {
    background-size: 100% auto;
    min-height: 39vw;
    background-position: top -27vw left calc(50% - 2vw);
  }
  @media (max-width: 1023px) {
    background-size: 170% auto;
    min-height: 130vw;
    background-position: top -37vw left calc(50% - 3.5vw);
  }
  @media (max-width: 640px) {
    background-size: 250% auto;
    min-height: 176vw;
    background-position: top -48vw left calc(50% - 3.5vw);
  }
}
</style>
